module.exports = __webpack_public_path__ + "static/media/Gusbourne White.29ce0858.avif";